import InterPayReport from './InterPayReport';

export default InterPayReport;
